<!--  -->
<template>
    <div class='wrapper box box_v'>
        <!-- 头部标题 -->
        <page-head title="居民登记卡配置" :btn-list="btnList" @handleBtn="handleBtn"></page-head>
        <div class="content box box_f1">
            <Card style="width: 100%">
              <div class="top-card">
                <div class="contentbox">
                  <div class="title">登记卡落款</div>
                  <Form ref="formInline" :label-width="60">
                    <row :gutter="60">
                      <i-col span="6">
                        <FormItem label="落款" prop="signName">
                          <Input v-model="signName" placeholder="请输入登记卡落款"/>
                        </FormItem>
                      </i-col>
                    </row>
                  </Form>
                </div>
                <div class="contentbox">
                  <div class="title">便民信息</div>
                  <!-- <Input v-model="people.name" placeholder="请输入真实姓名"/> -->
                  <Form ref="formInline" :label-width="60">
                    <row :gutter="40"  v-for="(item,index) in hotlineList" :key="index">
                      <i-col span="6">
                        <FormItem label="标题" prop="title">
                          <Input v-model="item.title" placeholder="请输入标题"/>
                        </FormItem>
                      </i-col>
                      <i-col span="6">
                        <FormItem label="电话" prop="phoneNO">
                          <Input v-model="item.phoneNO" placeholder="请输入电话"/>
                        </FormItem>
                      </i-col>
                      <i
                        class="iconfont icon-shanchu"
                        style="color: #d22b2b;line-height: 32px;"
                        @click="delItem(index)"
                      ></i>
                    </row>

                  </Form>
                  <div class="add-con" @click="addSelect">
                    <i class="iconfont icon-tianjiajiahaowubiankuang" style="font-size: 14px"></i>
                    <span>添加选项</span>
                  </div>
                </div>
                <div class="contentbox">
                  <div class="title">二维码</div>
                  <div style="position:relative;width:150px" @mouseover="mouseOver" @mouseleave="mouseLeave">
                    <img class="qrcode" :src="qrcodeUrl" v-if="qrcodeUrl"/>
                    <div class="qrcode qrtext" v-else>点此上传公众号二维码</div>
                    <div class="editpic" :style="display"  v-if="qrcodeUrl">
                      <i class="editicon iconfont icon-bianji1"></i>
                    </div>
                    <upload-img
                      class="uploadImg"
                      :style="display"
                      :imgArr="imgArr"
                      :imgNumber="imgNumber"
                      :imgHeight="150"
                      :imgWidth="150"
                      @saveImg="saveImg"
                      :isActive="isActive"
                    >
                      <div style="height:150px;width:150px"></div>
                    </upload-img>
                  </div>
                  <row :gutter="60">
                    <i-col span="6">
                      <Input v-model="qrcodeName" placeholder="请输入公众号名称"/>
                    </i-col>
                  </row>
                </div>
              </div>
              <div class="bottom-card">
                <div class="title">进出门登记</div>
                <div class="box" >
                  <div class="bottom-title">是否开启功能</div>
                  <RadioGroup v-model="isRegister">
                    <Radio :label="1">是</Radio>
                    <Radio :label="0">否</Radio>
                  </RadioGroup>
                </div>
                <div class="box ac" style="margin-top: 10px" v-show="isRegister">
                  <div class="bottom-title">是否有进/出门次数限制</div>
                  <RadioGroup v-model="isRegisterLimit">
                    <Radio :label="1">是</Radio>
                    <Radio :label="0">否</Radio>
                  </RadioGroup>
                  <div class="box ac">
                    <i style="margin-left: 10px">每&nbsp;</i>
                    <Input v-model="limitDay" type="number" style="width: 60px;" />
                    <i>&nbsp;天</i>
                    <i>&nbsp;&nbsp;进出各&nbsp;</i>
                    <Input v-model="limitNum" type="number" style="width: 60px;" />
                    <i>&nbsp;次</i>
                  </div>
                </div>
              </div>
              <div class="bottom-card">
                <div class="title">审核配置</div>
                <div class="box" >
                  <div class="bottom-title">未满14天是否可以审核</div>
                  <RadioGroup v-model="canShenhe">
                    <Radio :label="1">是</Radio>
                    <Radio :label="0">否</Radio>
                  </RadioGroup>
                </div>
              </div>
            </Card>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import pageHead from '../../../components/head';
import uploadImg from "../../../components/uplImgAct";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {pageHead,uploadImg},
    data() {
    //这里存放数据
        return {
            btnList: [{
                name: '保存',
                type: 'fabu',
                loading: false,
            }],//头部按钮
          signName:'',
            hotlineList:[],//便民热线
          qrcodeUrl:'',
          qrcodeName:'',
            display:'display: none',
            imgNumber: 1,
            imgArr: [],
            isActive: false,
          isRegister:0,
          isRegisterLimit:0,
          limitDay:0,
          limitNum:0,
          deleteHotlineList:[],
          canShenhe:0,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        //便民热线
        addSelect() {
            // if(this.hotlineList.length >= 10){
            //     this.$Message.info('最多可添加10个')
            //     return
            // }
            this.hotlineList.push({
                id:'',
                title:'',
                phoneNO:'',
                online24:0,
            });
        },
        delItem(idx){
          var item = this.hotlineList[idx]
          if (item.id) {
            item.id = 0-item.id
            this.deleteHotlineList.push(item)
          }
          this.hotlineList.splice(idx, 1)
        },
        //二维码相关
        mouseOver() {
            this.display = "";
        },
        mouseLeave() {
            this.display = "display: none";
        },
        saveImg(data) {
            this.qrcodeUrl = data.path;
        },
        handleBtn(type, index) {
            if (type == 'fabu') {
                this.submitSetting()
            }
        },
        submitSetting(){
            //信息必填判断
            if (!this.signName){
               this.$Message.error('请完善登记卡落款');
               return
            }
            // try{
            //     if(this.hotlineList.length==0){
            //          throw Error();
            //     }
            //     this.hotlineList.forEach(item=>{
            //         if(!item.title){
            //            throw Error();
            //         }
            //     })
            // } catch {
            //     this.$Message.error('请完善便民信息');
            //     return
            // }
            if((!this.qrcodeUrl) || (!this.qrcodeName)){
               this.$Message.error('请完善二维码信息');
               return
            }
            var data = {
              signName:this.signName,
              qrcodeName:this.qrcodeName,
              qrcodeUrl:this.qrcodeUrl,
              isOpen:this.isRegister,
              isLimit:this.isRegisterLimit,
              limitTimes:this.limitNum,
              limitMillisecond:this.limitDay * 86400000,
              messageList:[...this.hotlineList,...this.deleteHotlineList],
              isCheckUnreach14:this.canShenhe
            }
            this.btnList[0].loading = true
          this.$post(this.urlobj.editFangyiHotline,data).then(res => {
                this.$Message.success('保存成功')
                this.btnList[0].loading = false
                this.getInfo()
          })
        },
        getInfo(){
            this.$post(this.urlobj.getFangyiPeopleCardInfo,{
              pageNum:'',
              pageSize:'',
              communityId:'',
            }).then(res=>{
              var info = res.rows[0]
              this.signName = info.signName
              this.qrcodeName = info.qrcodeName
              this.qrcodeUrl = info.qrcodeUrl
              this.isRegister = info.isOpen
              this.isRegisterLimit = info.isLimit
              this.limitDay = info.limitMillisecond / 86400000
              this.limitNum = info.limitTimes
              this.canShenhe = info.isCheckUnreach14
              this.hotlineList = info.messageList.map(item => {
                return {
                  id:item.id,
                  title:item.title,
                  phoneNO:item.phoneNO,
                  online24:item.online24,
                }
              })
            }).catch(e=>{
                console.log(e)
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getInfo()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
/deep/ .ivu-card {
    height: 100%;
}

/deep/ .ivu-card-body {
    height: 100%;
}
/deep/ .ivu-radio-wrapper{
  font-size: 16px;
}
.wrapper {
    height: 100%;
}

.content {
    margin: 0 20px 20px 20px;
}
.title{
    font-weight: bold;
    margin-bottom: 20px;
    position: relative;
  font-size: 14px;
}
.title::after {
    content: "";
    position: absolute;
    left: -15px;
    top: 0;
    height: 20px;
    width: 3px;
    background-color: #ff7844
  }
//添加选项
 /deep/ .ivu-form .ivu-form-item-label {
    font-size: 16px;
  }

  /deep/ .ivu-form-inline .ivu-form-item {
    display: block;
  }
.add-con {
  font-size: 14px;
  color: #ff7b44;
  border: 1px solid #ff7b44;
  display: inline-block;
  height: 26px;
  line-height: 26px;
  border-radius: 5px;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 20px
}
//二维码编辑
.qrcode{
    width: 150px;
    height: 150px;
    margin-bottom: 20px;
}
.qrtext{
    border:1px solid #efefef;
    line-height: 150px;
    text-align: center
}
.uploadImg{
    position: absolute;
    top: 0;
    left: 0;
    width: 150px;
    height: 150px;
    z-index: 2
}
.editpic{
    width: 150px;
    height: 150px;
    background: rgba(0, 0, 0, 0.3);
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    .editicon {
      font-size: 40px;
      line-height: 150px;
      color: #fff;
      text-align: center
    }
}
  .top-card{
    border-bottom: 1px solid #dedede;
    padding-bottom: 20px;
  }
  .bottom-card{
    padding-top: 20px;
    font-size: 16px;
  }
  .bottom-title{

    margin-right: 20px;
  }
</style>
